module.exports = __webpack_public_path__ + "img/service.2871b7b.png";